/**
 * Color constants for AutomationV2 FlowCanvas
 * Centralized color definitions for consistent theming and easy maintenance
 */

export const FLOW_COLORS = {
  // Edge colors
  EDGE: {
    TRUE_BRANCH: '#059669', // Green for True branches
    FALSE_BRANCH: '#dc2626', // Red for False branches
    DEFAULT: '#000000', // Black for regular edges
    END_NODE: '#000000', // Black for End node edges
  },

  // Label colors
  LABEL: {
    TRUE_TEXT: '#059669', // Green text for True labels
    FALSE_TEXT: '#dc2626', // Red text for False labels
    DEFAULT_TEXT: '#374151', // Dark gray text for default labels
  },

  // Label background colors
  LABEL_BG: {
    TRUE: '#f0fdf4', // Light green background for True labels
    FALSE: '#fef2f2', // Light red background for False labels
    DEFAULT: '#fff', // White background for default labels
  },

  // Arrow/marker colors
  MARKER: {
    TRUE: '#059669', // Green arrow for True branches
    FALSE: '#dc2626', // Red arrow for False branches
    DEFAULT: '#000000', // Black arrow for regular edges
    END_NODE: '#000000', // Black arrow for End nodes
  },

  // Handle colors
  HANDLE: {
    DEFAULT: '#9ca3af', // Gray handles for connections
    BORDER: '#ffffff', // White border for handles
  },

  // Background colors
  BACKGROUND: {
    GRID: '#e5e8eb', // Grid background color
    CANVAS_CLASS: 'bg-grey-1', // Canvas background Tailwind class
  },

  // Border colors
  BORDER: {
    TRUE: '#059669', // Green border for True labels
    FALSE: '#dc2626', // Red border for False labels
    DEFAULT: '#000000', // Black border for default labels
  },
} as const;
